module.exports = __webpack_public_path__ + "files/527066973b12f4750b521bfa84503b48.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-8.png
// module id = 507
// module chunks = 76